import Vue from 'vue'
import Vuex from 'vuex'

import events from './modules/events'

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        loading: false,
    },
    modules: {
        events
    }
})


// WEBPACK FOOTER //
// ./src/store/store.js